export const workforceChecklistItemsV2 = [
  {
    key: 'workforceOccupation',
    label: 'Identify occupation path (kind of job to be performed).',
    confirmKey: 'confirmWorkforceOccupation',
    points: 4,
    due: 'During Phase 1',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'workforceResume',
    label: 'Build a sample resume and have it checked.',
    confirmKey: 'confirmWorkforceResume',
    points: 4,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'workforcePotentialEmployers',
    label: 'Create a list of potential employers in the area.',
    confirmKey: 'confirmWorkforcePotentialEmployers',
    points: 4,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'workforceReferences',
    label: 'Contact and get information for your references.',
    confirmKey: 'confirmWorkforceReferences',
    points: 2,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'workforceApplyJobs',
    label: 'Apply for full-time jobs.',
    confirmKey: 'confirmWorkforceApplyJobs',
    points: 4,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'workforceSecureHousing',
    label: 'Secure housing, pay deposits, and set moving date.',
    confirmKey: 'confirmWorkforceSecureHousing',
    points: 4,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'workforceTransportation',
    label: 'Secure reliable transportation (public transportation, rides, etc.)',
    confirmKey: 'confirmWorkforceTransportation',
    points: 4,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'workforceFollowUp',
    label: 'Follow-up on your job applications.',
    confirmKey: 'confirmWorkforceFollowUp',
    points: 4,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'workforceInterviews',
    label: 'Attend scheduled interviews.',
    confirmKey: 'confirmWorkforceInterviews',
    points: 4,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'workforceEquipment',
    label:
      'Look at the required equipment necessary prior to starting the training program.  Make a list of any tools that you will need.  Develop a plan for how you will plan to get the tools necessary.',
    confirmKey: 'confirmWorkforceEquipment',
    points: 4,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'workforceFirstDayOfWork',
    label: 'Identify your start date.',
    confirmKey: 'confirmWorkforceFirstDateOfWork',
    points: 2,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
];

export const workforceChecklistItems = [
  {
    key: 'workforceOccupation',
    label: '61. Identify occupation path (kind of job to be performed).',
    confirmKey: 'confirmWorkforceOccupation',
    points: 3,
    due: '2nd Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'workforceHousing',
    label: '62. Explore housing options.',
    confirmKey: 'confirmWorkforceHousing',
    points: 3,
    due: '2nd Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'workforceResume',
    label: '63. Build a sample resume and have it checked.',
    confirmKey: 'confirmWorkforceResume',
    points: 3,
    due: '2nd Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'workforceEmployers',
    label: '64. Create a list of potential employers in the area.',
    confirmKey: 'confirmWorkforceEmployers',
    points: 3,
    due: '2nd Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'workforceReferences',
    label: '65. Contact and get information for your references.',
    confirmKey: 'confirmWorkforceReferences',
    points: 4,
    due: '2nd Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'workforceJobApplications',
    label: '66. Apply for full-time jobs.',
    confirmKey: 'confirmWorkforceJobApplications',
    points: 4,
    due: 'March - April',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'workforceSecureHousing',
    label: '67. Secure housing, pay deposits, and set moving date.',
    confirmKey: 'confirmWorkforceSecureHousing',
    points: 4,
    due: 'April',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'workforceTransportation',
    label: '68. Secure reliable transportation (public transportation, rides, etc.)',
    confirmKey: 'confirmWorkforceTransportation',
    points: 4,
    due: 'April',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'workforceFollowupOnApps',
    label: '69. Follow-up on your job applications.',
    confirmKey: 'confirmWorkforceFollowupOnApps',
    points: 4,
    due: 'April',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'workforceInterviews',
    label: '70. Attend scheduled interviews.',
    confirmKey: 'confirmWorkforceInterviews',
    points: 4,
    due: 'April - May',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'workforceFirstDayOfWork',
    label: '71. Identify your start date.',
    confirmKey: 'confirmWorkforceFirstDateOfWork',
    points: 4,
    due: 'May',
    minVersion: 1,
    maxVersion: 1,
  },
  ...workforceChecklistItemsV2,
];
